// Libraries
import { useEffect, useState } from 'react';

// Utilities
import { getImageDimensions } from 'common/utils/helpers';

const useImageMapData = (imageUrl, padding = 500) => {
  const [mapData, setMapData] = useState();

  useEffect(() => {
    getImageDimensions(imageUrl).then(({ width, height }) => {
      const center = [height / 2, width / 2];
      const bounds = [
        [0, 0],
        [height, width],
      ];
      const maxBounds = [
        [-padding, -padding],
        [height + padding, width + padding],
      ];

      setMapData({ center, bounds, maxBounds });
    });
  }, []);

  return mapData;
};

export default useImageMapData;
